// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"7d16e5bd","232":"a5038cdd","354":"b3b2ee6d","386":"45b36196","453":"3667a62b","587":"6a3c3f06","620":"2052e8b9","851":"502928b7"}[chunkId] + ".chunk.js";
};